import React, { useEffect, useState, useRef } from 'react'

import '../../../styles.css'
import 'bootstrap/dist/css/bootstrap.min.css'


export default function ScanLabNumbersDisplay(props) {
    const {
        packageCode,
        sampleType,
        lab,
        // dateReceived,
        packageCodesArray,
        handleUpdateScanSamples,
        labOs,
        sampleTypeOs,
        handleSetReadyToAddToArray,
        handleSubmitSampleScan,
        submitting,
        handleCancelScan,
        handleRemoveScan
    } = props;

    const packageCodeRef = useRef(null);

    const [timeOutID, setTID] = useState("")

    const [labs, setlabOptions] = useState([{
        "Lab_ID": "",
        "Lab_VC": ""
    }])
    const [sampleTypes, setSampleTypes] = useState([{
        "SampleType_ID": "",
        "SampleType_VC": ""
    }])



    const handleSwitchInputs = (e) => {
        // console.log(e, e.target.value);
        clearTimeout(timeOutID)
        // Automatically focus on the next input field
        if (e.nativeEvent.key === 'Enter' || e.type === "change") {
            const id = setTimeout(() => {
                handleSetReadyToAddToArray(true)
            }, 500);
            setTID(id)
        } else {
            const id = setTimeout(() => {
                handleSetReadyToAddToArray(true)
            }, 500);
            setTID(id)
        }
    };



    useEffect(() => {
        if (sampleTypeOs.length && labOs.length) {
            setlabOptions(labOs)
            setSampleTypes(sampleTypeOs)
        }
    }, [sampleTypeOs, labOs])

    return (
        <>
            <div className="container-fluid px-2" style={{ "marginTop": "5px" }}>
                <div className="card mx-auto">
                    <div className="card-body">
                        <div className="service-heading mb-2" style={{ "marginTop": "-20px" }}>
                            Scan Sample
                        </div>
                        <hr style={{ "marginTop": "-20px" }} />
                        <div>
                            <div className="row">
                                <div className="col" style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }} >
                                    <label htmlFor="prefPackageCode" className="form-label service-form-label">
                                        Package Code:&nbsp;&nbsp;
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control service-form-control"
                                        id="prefPackageCode"
                                        value={packageCode}
                                        onChange={(e) => handleUpdateScanSamples(e)}
                                        onKeyDown={(e) => { handleSwitchInputs(e) }}
                                        ref={packageCodeRef}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: "10px", marginBottom: "20px" }}>
                                {/* <div className="col-sm-4">
                                    <label htmlFor="prefSampleType" className="service-form-label2">
                                        Date Received:&nbsp;&nbsp;
                                    </label>
                                    <input type="date" className="form-select service-form-control" id="prefDateReceived" value={dateReceived} onChange={(e) => handleUpdateScanSamples(e)} />
                                </div> */}
                                <div className="col-sm-6" >
                                    <label htmlFor="prefSampleType" className="service-form-label2">
                                        Sample Type:&nbsp;&nbsp;
                                    </label>
                                    <select className="form-select service-form-control" id="prefSampleType" value={sampleType.SampleType_VC} onChange={(e) => handleUpdateScanSamples(e)}>
                                        <option value="" disabled>--Select--</option>
                                        {sampleTypes.map((state, index) =>
                                            <option key={index} value={state.SampleType_VC}>{state.SampleType_VC}</option>
                                        )}
                                    </select>
                                </div>
                                <div className="col-sm-6">
                                    <label htmlFor="prefSampleType" className="service-form-label2">
                                        Lab:&nbsp;&nbsp;
                                    </label>
                                    <select className="form-select service-form-control" id="prefLab" value={lab.Lab_VC} onChange={(e) => handleUpdateScanSamples(e)}>
                                        {labs.map((state, index) =>
                                            <option key={index} value={state.Lab_VC}>{state.Lab_VC}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-1' />
                                <div className='col-sm-10' style={{ height: "250px", border: "4px inset", overflowY: "hidden", overflow: "scroll" }}>
                                    {packageCodesArray && packageCodesArray.length > 0 &&
                                        packageCodesArray.map((state, index) =>
                                            <div className='row' key={index}>
                                                <div className='col-sm-8'>{state}</div>
                                                <div className='col-sm-4' style={{ display: "flex", justifyContent: "flex-end" }}><button className='remove-scan-btn' onClick={() => handleRemoveScan(state)}>REMOVE</button></div>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className='col-sm-1' />
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    {sampleType.SampleType_ID !== "" && lab.Lab_ID !== "" && packageCodesArray.length > 0 &&
                                        <button type="button" className={submitting ? "button-max-secondary" : "button-max-primary"} onClick={submitting ? undefined : (e) => handleSubmitSampleScan(e)}>{submitting ? 'Submitting...' : 'Submit'}</button>
                                    }
                                    {(sampleType.SampleType_ID === "" || lab.Lab_ID === "" || packageCodesArray.length === 0) &&
                                        <button type="button" className="button-max-secondary">Submit</button>
                                    }
                                </div>
                                <div className="col-sm-6">
                                    <button type="button" className="button-max-secondary" onClick={(e) => handleCancelScan(e)}>Reset</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


